import { Image, RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import clsx from 'clsx';
import React from 'react';
import { dateFormat } from '../Shared/Helpers/dateTimeHelper';
import Button from '../Shared/components/controls/Button';
import { SwiperSlide } from 'swiper/react/swiper-react.js';

const Item = ({ data = {}, i18n, swiperSlide }) => {
  const { author, backgroundColor, badge, date, heading, image, imageAlignment, link, text } = data;
  const shouldRenderAuthor = !!author?.value;
  const shouldRenderBadge = !!badge?.value;
  const shouldRenderDate = !!date?.value && !date?.value?.startsWith('0001');
  const shouldRenderHeading = !!heading?.value;
  const shouldRenderImage = !!image?.value?.src;
  const shouldRenderImageAlignment = !!imageAlignment?.fields?.DropdownValue?.value;
  const shouldRenderLink = !!link?.value?.href;
  const shouldRenderText = !!text?.value;

  let style, leftStyle, rightStyle, imageOrder;
  const alignment = imageAlignment?.fields?.DropdownValue?.value?.toLowerCase();
  if (shouldRenderImageAlignment) {
    switch (alignment) {
      case 'imageAtTheLeft'.toLowerCase():
        style = 'col-12';
        leftStyle = 'col-12 col-lg-4';
        rightStyle = 'col-12 col-lg-8';
        imageOrder = 1;
        break;
      case 'imageAtTheLeft_SameSize'.toLowerCase():
        style = 'col-12 col-lg-8';
        leftStyle = 'col-12 col-lg-6';
        rightStyle = 'col-12 col-lg-6';
        imageOrder = 1;
        break;
      case 'imageAtTheRight'.toLowerCase():
        style = 'col-12';
        leftStyle = 'col-12 col-lg-4';
        rightStyle = 'col-12 col-lg-8';
        imageOrder = 2;
        break;
      case 'imageAtTheRight_SameSize'.toLowerCase():
        style = 'col-12 col-lg-8';
        leftStyle = 'col-12 col-lg-6';
        rightStyle = 'col-12 col-lg-6';
        imageOrder = 2;
        break;
      case 'noImage'.toLowerCase():
        style = 'col-12 col-lg-4';
        leftStyle = 'col-12';
        break;
      default:
        style = 'col-12';
        leftStyle = 'col-12';
        rightStyle = 'col-12';
        break;
    }
  }

  let dateRes = {
    value: '',
  };
  if (shouldRenderDate) {
    let formattedDate = dateFormat(date?.value, i18n.language);
    dateRes = {
      value: `${formattedDate.month} ${formattedDate.day}, ${formattedDate.year}`,
    };
  }

  const renderItems = () => {
    return (
      <>
        <div
          className={clsx(
            'left-side-content right-side-content',
            leftStyle,
            rightStyle,
            backgroundColor?.fields?.DropdownValue?.value
          )}
        >
          {(shouldRenderDate || shouldRenderBadge) && (
            <div className="badge-date">
              {shouldRenderBadge && (
                <div className="badge-content">
                  <Text field={badge} />
                </div>
              )}
              {shouldRenderDate && (
                <div className="date-content">
                  <Text field={dateRes} />
                </div>
              )}
            </div>
          )}
          {shouldRenderHeading && (
            <div className="heading-content">
              <Text field={heading} />
            </div>
          )}
          {shouldRenderText && <RichText className="text-content" field={text} />}
          {shouldRenderAuthor && (
            <div className="author-content">
              <Text field={author} />
            </div>
          )}
          {shouldRenderLink && (
            <Button
              link={link}
              className="link-content button-text-primary-arrow-right"
              arrow="right"
              variant="text"
              color="primary"
            />
          )}
        </div>
        {rightStyle && shouldRenderImage && (
          <div className={clsx('right-side-content', rightStyle)}>
            <Image field={image} />
          </div>
        )}
      </>
    );
  };

  return !swiperSlide ? (
    <div
      className={clsx('single-insight row', style, imageOrder === 1 ? 'image-first' : 'image-last')}
    >
      {renderItems()}
    </div>
  ) : (
    <SwiperSlide
      className={clsx('single-insight row', style, imageOrder === 1 ? 'image-first' : 'image-last')}
    >
      {renderItems()}
    </SwiperSlide>
  );
};

Item.displayName = 'SwiperSlide';

export default Item;
